import React from "react";
import { Box, Typography } from "@mui/material";

// Mapping keywords to logo image paths (fallbacks)
const logoMap = {
  NAAC: "/assets/images/university-logo/naac-logo.png",
  NIRF: "/assets/images/university-logo/nirf-logo.png",
  NBA: "/assets/images/university-logo/nba-logo.jpg",
  AICTE: "/assets/images/university-logo/aicte-logo.webp",
  UGC: "/assets/images/university-logo/ugc-logo.png",
  WES: "/assets/images/university-logo/wes-logo.png",
  ABET: "/assets/images/university-logo/abet-logo.png",
  AACSB: "/assets/images/university-logo/aacsb-logo.png",
};

const getLogo = (option) => {
  if (option?.image) return option.image; // backend image if present
  if (option?.label) {
    for (const key in logoMap) {
      if (option.label.toUpperCase().startsWith(key)) {
        return logoMap[key];
      }
    }
  }
  return "/assets/images/university-logo/default-logo.png"; // fallback
};

const AccreditationDefault = ({
  option,
  renderUploadSection,
  readOnly = false,
  data = {},
  onChange,
}) => {
  const logo = getLogo(option);

  return (
    <Box display="flex" gap={2}>
      <Box sx={{ width: 80, pt: 1 }}>
        <img
          src={logo}
          alt={option?.label || "Accreditation Logo"}
          style={{ maxWidth: "100%", height: "auto" }}
        />
      </Box>
      <Box flex={1}>
        <Typography fontSize={14} fontWeight={600} color="#15243E" mb={2}>
          {option?.label}
        </Typography>
        {renderUploadSection()}
      </Box>
    </Box>
  );
};

export default AccreditationDefault;
